module.exports = __webpack_public_path__ + "static/lerna-wizard-demo-82092142a21998ac31e36e7e680057bb.gif";